import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';
import { ApiResponse } from '../shared/types';

/** `inactive`: washes are left but the purchase isn't paid (or its order is pending/cancelled). */
export type PrepaidPassState = 'active' | 'inactive' | 'expired' | 'used' | 'cancelled';

export interface PrepaidPassItem {
  /** Package name, or the humanized wash type when the package has none. */
  name: string;
  remaining: number;
  limit: number;
  expired: boolean;
}

/** Pass DTO returned by POST /api/v1/order/public/prepaid-pass (svc-order, CWS-1835). */
export interface PublicPrepaidPass {
  shopName: string | null;
  packageName: string | null;
  orderNumber: string | null;
  state: PrepaidPassState;
  /** Formatted in the shop's timezone, e.g. "Wed, Dec 23, 2026". */
  validTill: string | null;
  items: PrepaidPassItem[];
  /** PNG data URL of the check-in QR staff scan; null unless the pass is active. */
  qrCode: string | null;
}

/**
 * Unauthenticated client for the prepaid pass behind the purchase SMS check-in link.
 * POST /api/v1/order/public/prepaid-pass — load a pass by its redemption token.
 */
@Injectable({ providedIn: 'root' })
export class PrepaidPassPublicService {
  constructor(private readonly api: ApiService) {}

  loadPass(token: string): Observable<ApiResponse<PublicPrepaidPass>> {
    return this.api.postWithoutAuth<PublicPrepaidPass>('order/public/prepaid-pass', { token });
  }
}
